/**
 * Cross-cutting string constants the frontend and Go backend must agree on.
 *
 * Two N-400-related values look almost identical but mean different things:
 *
 * - CASE_TYPE_N400 ("N400", no hyphen) — domain enum on the cases table.
 *   Enforced by `cases.case_type CHECK ('N400')` in
 *   services/api/migrations/0004_cases_persons.sql and validated by
 *   services/api/internal/cases/handlers.go::supportedCaseTypes. Sent in
 *   POST /v1/cases body.
 *
 * - FORM_N400.code ("N-400", with hyphen) — USCIS form code, used as the
 *   `{form_type}` URL segment in form-response routes and as the registry
 *   key in services/api/internal/formmapping/n400_2025_01_20.go.
 *
 * Don't introduce a third spelling. Always import from here.
 */

/** Domain enum for the cases table — no hyphen. */
export const CASE_TYPE_N400 = "N400" as const;

/** USCIS form identifier — hyphen + edition date. */
export const FORM_N400 = {
  code: "N-400",
  edition: "2025-01-20",
} as const;
